/* unplugin-vue-components disabled */import script from "./ResetPass.vue?vue&type=script&setup=true&lang=js"
export * from "./ResetPass.vue?vue&type=script&setup=true&lang=js"

import "./ResetPass.vue?vue&type=style&index=0&id=70e6604d&lang=stylus"

const __exports__ = script;

export default __exports__